import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { API_URL_All } from '../../api';
import axiosInstance from '../../axiosInstance';
import { toast } from "react-toastify";
import * as general from '../../libs/general';

const VoteEditor = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);
  const [model, setModel] = useState({});

  useEffect(() => {
    setModel(data);
    setShow(true);
  }, [data]);

  const clearUrlParam = () => {
    const hash = window.location.hash;

    if (hash.includes('?')) {
      const cleanHash = hash.split('?')[0];
      const newUrl = window.location.origin + window.location.pathname + cleanHash;
      window.history.replaceState(null, '', newUrl);
    }
  }
  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });

    clearUrlParam();
    document.activeElement.blur();
    setShow(false);
    if (handleSearch) handleSearch();
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    try {
      var requestApi = `/api/providers/createProviderComment`;
      var dataModel = removeSaoFromObject(model);
      const response = await axiosInstance.post(requestApi, dataModel);
      if (!response.data.success) {
        general.showFormError('#form_fee_editor .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      if (handleSearch) handleSearch();
      handleModalClose();
      window.dispatchEvent(new Event('refresh-operation-info'));
    } catch (error) {
      general.showFormError('.show .modal-body', error.response.data);
    }

  };
  function removeSaoFromObject(obj) {
    const updated = {};

    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        updated[key] = obj[key].replace(/ sao/g, '');
      } else {
        updated[key] = obj[key];
      }
    }

    return updated;
  }

  return (
    <Modal show={show} onHide={handleModalClose} size="md">
      <div className="">

        <form id="form_fee_editor" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{!model.id && <span>Đánh giá NCC: <b>{model.providerName}</b></span>}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-6 col-md-4">
                      <label className="form-label"><span className="required">Chất lượng sản phẩm</span></label>
                      <div className="th filter-editor">
                        <span className="filter-ib" data-source-key="editor_stars">
                          <input type="text" placeholder="Số sao" data-required="Phải nhập mục này" value={model.starProduct ?? ''} onChange={(e) => setModel({ ...model, starProduct: e.target.value })} />
                        </span>
                      </div>
                    </div>
                    <div className="col-6 col-md-4">
                      <label className="form-label"><span className="required">Giá cả</span></label>
                      <div className="th filter-editor">
                        <span className="filter-ib" data-source-key="editor_stars">
                          <input type="text" placeholder="Số sao" data-required="Phải nhập mục này" value={model.starPrice ?? ''} onChange={(e) => setModel({ ...model, starPrice: e.target.value })} />
                        </span>
                      </div>
                    </div>
                    <div className="col-6 col-md-4">
                      <label className="form-label"><span className="required">Giao hàng</span></label>
                      <div className="th filter-editor">
                        <span className="filter-ib" data-source-key="editor_stars">
                          <input type="text" placeholder="Số sao" data-required="Phải nhập mục này" value={model.starProcess ?? ''} onChange={(e) => setModel({ ...model, starProcess: e.target.value })} />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mb-3">

                  <div className="row mt-3">
                    <label className="form-label col-form-label col-sm-4 col-4"><span className="">Ý kiến</span></label>
                    <div className="col-sm-8 col-8"><input name="name" placeholder="..." type="text" className="form-control" value={model.content ?? ""} onChange={(e) => setModel({ ...model, content: e.target.value })} /></div>
                  </div>
                </div>
              </div>



            </div>
            <div className="modal-footer justify-content-between">
              <div>

              </div>
              <button type="submit" className="btn-sm btn btn-primary">Gửi đánh giá</button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default VoteEditor;
